module.exports = __webpack_public_path__ + "static/media/red_chips_waiting.6275e3f2.svg";